import _regeneratorRuntime from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { createIntl, createIntlCache } from 'react-intl';
import axios from 'axios';
var cache = createIntlCache();
export var ReactIntl = function ReactIntl(lng, ns) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var messages;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            messages = {};
            _context.prev = 1;
            _context.next = 4;
            return axios.get("https://assets.designs.ai/locales/".concat(lng, "/").concat(ns, ".json"));

          case 4:
            messages = _context.sent.data;
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0);

          case 10:
            return _context.abrupt("return", createIntl({
              // Locale of the application
              locale: lng,
              // Locale of the fallback defaultMessage
              defaultLocale: 'en',
              messages: messages
            }, cache));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[1, 7]]);
  }));
};
export var InitIntl = function InitIntl() {
  return createIntl({
    // Locale of the application
    locale: 'en',
    // Locale of the fallback defaultMessage
    defaultLocale: 'en',
    messages: {}
  }, cache);
};